module.exports = __webpack_public_path__ + "static/storia_2_small-527da9b3caf9cb6a0d743bc0b44b4f93.jpg";